import { Config } from '../config/env.config';
import { ActiveFilterModel } from '../search/active-filters/active-filter.model';

export class FitmentsSearchModel {
  sortDir: string = ''; // asc, desc
  sortCol: string = ''; // sort column
  currentPage: number = 1; // Current Page Number
  itemsPerPage: number = 25; // The number of items to show per page
  search: string = ''; // The user entered search string
  filters: Array<ActiveFilterModel> = [];
}
